import moment from "moment";
import { CustomField } from "./custom-fields.types";

/**
 * Returns true if the custom field applies to the given evidence type id.
 * - Fields with empty/null type_ids are "applies to all" and always return true.
 * - If the type id is undefined/null (e.g. unresolved), restricted fields
 *   return false. This mirrors the canonical pattern used by the create/edit
 *   form (see EvidenceCustomFieldsForm, EvidenceDetailsDisplay, and
 *   resolveCustomFieldValidations).
 */
export function isCustomFieldApplicableToType(
  field: Pick<CustomField, "type_ids">,
  typeId: number | undefined | null
): boolean {
  if (!field.type_ids || field.type_ids.length === 0) return true;
  if (typeId === undefined || typeId === null) return false;
  return field.type_ids.includes(typeId);
}

// Same parse as monolithMoment: bare YYYY-MM-DD dateBox values are local
// midnight (new Date reads them as UTC, the previous day west of UTC), and
// longer values (evidence import's db_timestamp) are UTC.
export function getCustomAttributeCellValue(
  rowData: {
    custom_attributes?: { field_id: number; value?: string | null }[];
  },
  attribute: Pick<CustomField, "field_id" | "editor_type">
) {
  const field = rowData.custom_attributes?.find(
    (item) => item.field_id === attribute.field_id
  );
  if (!field) return;
  if (attribute.editor_type === "dateBox") {
    const value = field.value;
    if (!value) return null;
    const isDateOnly = typeof value === "string" && value.length < 11;
    return (isDateOnly ? moment(value) : moment.utc(value).local()).toDate();
  }
  if (field.value && attribute.editor_type === "tagBox") {
    try {
      return JSON.parse(field.value).join(", ");
    } catch (e) {
      return field.value;
    }
  }
  return field.value;
}
